import React from 'react';
import { CommonAppProviders } from '../../app/common-app/CommonAppProviders';
import { ReduxProviders } from '../../app/common-app/ReduxProviders';

export const SignUpContext = React.createContext<{}>({
  phoneNumber: '',
  email: '',
  source: null,
  sourcePage: null,
  isICP: false,
  savePhoneNumber: () => {},
  saveEmail: () => {},
  saveSource: () => {},
  saveIsICP: () => {},
});

type Props = {
  children: React.ReactNode;
};

type State = {
  phoneNumber: string;
  email: string;
  source: string;
  sourcePage: string;
  isICP: boolean;
};

export class SignUpProvider extends React.Component<Props, State> {
  state: State = {
    phoneNumber: '',
    email: '',
    source: '',
    sourcePage: '',
    isICP: false,
  };

  savePhoneNumber = (phoneNumber: string) => {
    this.setState({ phoneNumber });
  };

  saveEmail = (email: string) => {
    this.setState({ email });
  };

  saveSource = (source: string, sourcePage: string) => {
    this.setState({ source, sourcePage });
  };

  saveIsICP = () => {
    this.setState({ isICP: true });
  };

  render() {
    return (
      <ReduxProviders>
        <CommonAppProviders isLoggedIn={window.logged_in}>
          <SignUpContext.Provider
            value={{
              phoneNumber: this.state.phoneNumber,
              savePhoneNumber: this.savePhoneNumber,
              email: this.state.email,
              isICP: this.state.isICP,
              saveIsICP: this.saveIsICP,
              saveEmail: this.saveEmail,
              source: this.state.source,
              sourcePage: this.state.sourcePage,
              saveSource: this.saveSource,
            }}
          >
            {this.props.children}
          </SignUpContext.Provider>
        </CommonAppProviders>
      </ReduxProviders>
    );
  }
}

export function withSignUp(Component: typeof React.Component) {
  return function ComponentWithSignUp(props: any) {
    return (
      <SignUpContext.Consumer>
        {(data) => <Component {...props} {...data} />}
      </SignUpContext.Consumer>
    );
  };
}
